import React from 'react';
import { Field } from 'formik';
import Device from '../device/device';
import { IDevice } from 'src/features/common/types/fees-slider-types';
import { Checkbox, MiniAppFocusWrapper } from 'src/components';
import { InputField } from 'src/features/common';
import { turnoverMask } from 'src/helpers/formatting';
import { BOUNDS } from '../../pages/business-details/resources/bounds';
import './choose-your-device.scss';

interface ChooseDeviceProps {
  devices: IDevice[];
  onClick: (index: number) => void;
  noTurnoverAmount: boolean;
}

const ChooseYourDevice = ({ devices, onClick, noTurnoverAmount }: ChooseDeviceProps) => {
  return (
    <div className="choose-your-device">
      <h3 className="choose-your-device-title">Choose your device(s)</h3>

      <div className="devices-container">
        {devices.map(({ icon, name, functionality, active }, index) => (
          <Device
            key={index}
            icon={icon}
            name={name}
            functionality={functionality}
            active={active}
            onClick={() => onClick(index)}
          />
        ))}
      </div>

      <div className="fees-slider-form">
        <Field
          name="turnoverAmount"
          id="turnoverAmount"
          type="tel"
          placeholder="How much money do you process monthly?"
          mask={(e: Event) => ['R', ' ', ...turnoverMask(e)]}
          guide={false}
          maxLength={BOUNDS.NAME_LENGTH}
          component={MiniAppFocusWrapper}
          innerComponent={InputField}
          fieldType="masked"
          className="light top-field"
          disabled={noTurnoverAmount}
        />
        <Field
          name="dontKnowTurnover"
          type="checkbox"
          component={Checkbox}
          checkboxText={() => <p>I don't know how much I will process monthly</p>}
          fullWidth={true}
          isLightMode={true}
          disabled={false}
        />
      </div>
    </div>
  );
};

export default ChooseYourDevice;
